<template>
  <b-modal
    id="admin-information-dialog"
    scrollable
    hide-backdrop
    @hide="onClose">
    <template #modal-header>
      <div class="dialog-header">
        <h5 class="dialog-title">
          {{ info.title }}
        </h5>
      </div>
    </template>
    <div>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <p v-html="sanitizedLink(info.text)" />
    </div>
    <template #modal-footer>
      <div class="dialog-footer">
        <div class="mb-3 text-center">
          <b-form-checkbox @change="(e) => toggleNotDisplayInfo(e)">
            今後このお知らせを表示しない
          </b-form-checkbox>
        </div>
        <button
          type="button"
          class="btn btn-block close-button outline"
          @click="onHide">
          閉じる
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import sanitizedLinkMixin from '@/components/mixin/sanitizedLink'

export default {
  mixins: [sanitizedLinkMixin],
  props: {
    info: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      notDisplayInfo: false
    }
  },
  methods: {
    onClose() {
      this.$emit('close', this.notDisplayInfo)
    },
    onHide() {
      this.$bvModal.hide('admin-information-dialog')
    },
    toggleNotDisplayInfo(bool) {
      this.notDisplayInfo = bool
    },
  }
}
</script>

<style lang="scss">
#admin-information-dialog {
  .modal-content {
    border: solid 2px $l-blue;
    color: $l-blue;
  }

  .dialog-title {
    font-weight: bold;
    font-size: $fs-lg;
  }

  .modal-header {
    border-bottom: none;
    padding-bottom: 0;
  }

  .modal-footer {
    border-top: none;
    display: block;
    padding-top: 0;
  }

  .close-button {
    font-size: $fs-m;
    padding: 12px 16px;
    width: 100%;
    background-color: $l-blue;
    color: $white;
  }
}
</style>